let genIdNum = 0;

const generateId = (prefix = "") => {
  genIdNum++;
  return prefix + new Date().getTime().toString() + "_" + genIdNum.toString();
};

export default generateId;
